import React from 'react';
import SubmissionLinkManager from '../components/SubmissionLinkManager';

const SubmissionLinks = () => {
  return (
    <div className="submission-links-page">
      <SubmissionLinkManager />
    </div>
  );
};

export default SubmissionLinks;
